import { dataFetcher } from '../Utils/dataFetcher'
import config from '../../temp/config'
import { CacheService } from '../Utils/Caching/cacheService'

interface List {
  Path: string
  Dictionary: unknown
}
export type GetFoundationListType = (cache: CacheService, paths: string[]) => Promise<List[]>
export const getFoundationList = async (cache: CacheService, paths: string[]): Promise<List[]> => {
  let cachedLists: List[] = []
  let fetchedLists: List[] = []

  const urlPathsToFetch = paths
    .map((path) => {
      // find path in cache
      const valueInCache = cache.get(path)
      // if path is not in cache - we will fetch it
      if (!valueInCache) {
        return `&paths=${path}`
      }
      // due to possible cache expiration we need to save cache into temporary array
      cachedLists = [...cachedLists, { Path: path, Dictionary: valueInCache }]
      return
    })
    .join('')

  try {
    const response = await dataFetcher<List[]>(
      `${config.sitecoreApiHost}/api/discoverywebsite/foundation/lists?language=${config.defaultLanguage}${urlPathsToFetch}`
    )
    const data = response.data as List[]
    data.forEach((item: List) => {
      cache.set(item.Path, item.Dictionary)
      fetchedLists = [...fetchedLists, item]
    })
    return [...cachedLists, ...fetchedLists]
  } catch (error) {
    console.error(error)
    return await Promise.reject(error)
  }
}

//  DON'T DELETE - used by DW
